import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Award, Users, Clock, Star } from 'lucide-react';
import './AboutSection.css';

const AboutSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      icon: <Award size={24} />,
      title: 'Expert Craft',
      description: 'Professionally qualified craftsmen with years of experience'
    },
    {
      icon: <Users size={24} />,
      title: 'Client-Focused',
      description: 'We work closely with clients to understand their vision'
    },
    {
      icon: <Clock size={24} />,
      title: 'Timely Delivery',
      description: 'Projects completed on time and within budget'
    },
    {
      icon: <Star size={24} />,
      title: 'Premium Quality',
      description: 'High-quality imported fittings and materials'
    }
  ];

  return (
    <section id="about" className="section about-section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="about-content"
        >
          <div className="about-text">
            <div className="section-title">
              <h2>JMJ: Kerala's Expert Interior Designer</h2>
              <p>
                Creating charming, ambient interior spaces for homes, hotels, offices,
                and commercial properties across Kerala.
              </p>
            </div>

            <div className="about-description">
              <p>
                JMJ Interior & Furniture is the best interior designer based in Kottayam
                with years of experience crafting some of the finest interior decoration
                projects in Kerala. We create your dream furniture and interior with our
                team of professionally qualified craftsmen.
              </p>

              <p>
                Whether you live in a coastal area like Kochi or in the uphill area like
                Munnar, JMJ builds weather-durable and long-lasting interior decoration.
                We provide interior design services in Kottayam, Idukki, Pathanamthitta,
                Thiruvalla, Ernakulam, Kochi, and Alappuzha.
              </p>
            </div>
          </div>

          <div className="about-image">
            <img
              src="/images/s2naalukett.jpg"
              alt="JMJ Interior Design Work"
              className="main-image"
            />
            <div className="image-overlay">
              <div className="experience-badge">
                <span className="years">15+</span>
                <span className="text">Years of Excellence</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="features-grid"
        >
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;